import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.green};
  margin-bottom: 20px;
  padding-left: 12px;
  padding-top: 10px;
`

export const Field = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;

  margin-bottom: 5px;
  padding-left: 12px;
`

export const Value = styled.div`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;

  margin-top: 3px;
  margin-bottom: 20px;
  padding-left: 12px;
`

export const ContainerBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`

export const BodyRow = styled.div`
  width: 100%;
  display: flex;
  padding-bottom: 20px;
  div {
    width: 50%;
  }
`
